import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import styles from './ListItem.module.scss';
import ListItem from './ListItem';

const ListMode = ({ users, onScroll, loading }) => (
  <Box className={styles.connectedUsers} onScroll={onScroll}>
    {users && users.map((user) => <ListItem user={user} />)}
    {loading && (
      <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
        <CircularProgress
          sx={{
            width: '40px !important',
            height: '40px !important',
          }}
        />
      </Box>
    )}
  </Box>
);

export default ListMode;
